export const STORE_LOYALTY_START = 'STORE_LOYALTY_START';
export const STORE_LOYALTY_SUCCESS = 'STORE_LOYALTY_SUCCESS';
export const STORE_LOYALTY_FAILURE = 'STORE_LOYALTY_FAILURE';

export const SET_V_ERRORS = 'SET_V_ERRORS';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';

export const CONFIRM_PHONE_START = 'CONFIRM_PHONE_START';
export const CONFIRM_PHONE_SUCCESS = 'CONFIRM_PHONE_SUCCESS';
export const CONFIRM_PHONE_FAILURE = 'CONFIRM_PHONE_FAILURE';

export const SET_LOADER = 'SET_LOADER';
